module.exports = __webpack_public_path__ + "img/icon-singout.9af47ae6.png";